import { GuardTourQuery } from '@/graphql/generated/operations'
import { formatDateTimeWithAt } from '@/utils/formatDateTime'

import { CheckpointIProps, GuardTourType } from '../types/types'

export const groupByFloor = (checkpoints: CheckpointIProps[]) => {
  return checkpoints?.reduce((acc, cur) => {
    acc[cur.floor] = acc[cur.floor] || []
    acc[cur.floor].push(cur)
    return acc
  }, Object.create(null))
}

export const formatCheckpoints = (
  checkpoints: GuardTourQuery['guardTour']['tourPlan']['checkpoints'],
  completedCheckpoints
) => {
  return checkpoints?.edges.map((checkpoint) => {
    const node = checkpoint.node
    const c = completedCheckpoints?.find(
      (cc) => cc?.checkpoint?.id === checkpoint?.node?.id
    )
    return {
      id: node?.id,
      displayId: node?.displayId,
      name: node?.device?.name,
      scanned: Boolean(c?.scannedAt),
      time: c?.scannedAt,
      floor: node?.device?.floor?.name,
    }
  })
}

export const formatData = (
  guardTour: GuardTourQuery['guardTour']
): GuardTourType => {
  const completedCheckpoints = guardTour?.completedCheckpoints?.edges?.map(
    (c) => c.node
  )
  return {
    id: guardTour?.id,
    name: guardTour?.tourPlan?.name,
    startedAt: formatDateTimeWithAt(guardTour?.createdAt),
    submittedAt: formatDateTimeWithAt(guardTour?.updatedAt),
    guardFullName: `${guardTour?.guard?.firstName} ${guardTour?.guard?.lastName}`,
    status: guardTour?.status,
    checkpoints: guardTour?.completedCheckpoints
      ? Object?.entries(
          groupByFloor(
            formatCheckpoints(
              guardTour?.tourPlan?.checkpoints,
              completedCheckpoints
            )
          )
        )
      : [],
  }
}
